import { COLORS, FlexView } from '@cuemath/comps';
import { Button, Separator, Text } from '@cuemath/web-comps';
import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const Wrapper = styled(FlexView)`
  border: 1px solid ${COLORS.GRAY_XLIGHT};
  border-radius: 8px;
`;
const ButtonWrapper = styled(Button)`
  margin-left: 8px;
`;
const StyledLine = styled(Separator)`
  width: 1px;
  margin: 0px 8px;
`;

const StudentDetails = ({
  id,
  prospectID,
  name,
  parentName,
  phone,
  grade,
  schoolBoard,
}) => {
  const onViewStudentDetails = () => window.open(`/students/${id}`, '_blank');

  return (
    <Wrapper gutter={24} gap={16} flexDirection="row" justifyContent="space-between">
      <FlexView flexDirection="row" alignItems="center">
        <Text variant="cta1" color={COLORS.GRAY_LIGHT}>
          #{prospectID}
        </Text>
        <ButtonWrapper
          variant="tertiaryWithUnderline"
          size="medium"
          onClick={onViewStudentDetails}
          label={name}
        />
      </FlexView>
      <FlexView flexDirection="row" alignItems="center">
        <Text variant="body2" color={COLORS.COLA_LIGHTER}>
          {`Parent: ${parentName}`}
        </Text>
        <StyledLine height={16} color={COLORS.COLA_LIGHTER} />
        <Text variant="body2" color={COLORS.COLA_LIGHTER}>
          {`${phone}`}
        </Text>
        <StyledLine height={16} color={COLORS.COLA_LIGHTER} />
        <Text variant="body2" color={COLORS.COLA_LIGHTER}>
          {`${schoolBoard} - Grade ${grade}`}
        </Text>
      </FlexView>
    </Wrapper>
  );
};

StudentDetails.propTypes = {
  id: PropTypes.string,
  prospectID: PropTypes.string,
  name: PropTypes.string,
  parentName: PropTypes.string,
  phone: PropTypes.string,
  grade: PropTypes.string,
  schoolBoard: PropTypes.string,
};

export default StudentDetails;
